<div style="
 display: flex;
 flex-direction: row;
 justify-content: space-between;
 align-items: baseline;
 ">
    @if (mode === "Update") {
    <h2>Edit contact @if (contact.archived) {<span>(Archived)</span>}</h2>
    } @else {
    <h2>Create new contact</h2>
    }
    <div class="n-last-modifications">
        @if (contact.lastModifiedOn) {
        Last update: {{ contact | lastUpdate }}
        }
    </div>
</div>

<div>
    <mat-accordion class="example-headers-align" multi>
        <mat-expansion-panel class="n-common-data-panel"
            [style.background-color]="(contact.archived ? 'var(--nexus-archived-color)' : 'inherit')" [expanded]="true">
            <form [formGroup]="commonDataFG" class="form-container">
                <div style="padding: 6px; display: flex; flex-direction: column; gap: 10px">
                    <fieldset
                        style="display: flex; gap: 10px; border-radius: var(--nexus-border-radius); align-items: baseline ">
                        <legend>Contact name</legend>
                        <mat-form-field appearance="outline" [style.width.px]="300" style="width: 300px">
                            <mat-label>First name</mat-label>
                            <input matInput type="text" formControlName="firstName" />
                            @if (commonDataFG.get("firstName")?.invalid &&
                            commonDataFG.get("firstName")?.touched) {
                            <mat-error> First name is required.</mat-error>
                            }
                            <mat-hint>
                                @if ((duplicateEntryResource.status() == 'resolved') &&
                                (((duplicateEntryResource.value()?.matchingItems ?? []).length > 0) ||
                                ((duplicateEntryResource.value()?.similarItems ?? []).length > 0))){
                                <span class="n-duplicate-warning">{{
                                    duplicateEntryResource.value()|
                                    similarityList:'nameSimilarity':0.95:['firstName','lastName'] }}</span>
                                }
                                @if (duplicateEntryResource.status() == 'error') {
                                <span class="n-duplicate-error">Error checking for similar entries</span>
                                }
                            </mat-hint>
                        </mat-form-field>
                        <mat-form-field appearance="outline" [style.width.px]="300">
                            <mat-label>Last name</mat-label>
                            <input matInput type="text" formControlName="lastName" />
                            @if (commonDataFG.get("lastName")?.invalid) {
                            <mat-error> Last name is required.</mat-error>
                            }
                        </mat-form-field>

                        @if (duplicateEntryResource.status() == 'loading') {
                        <div class="spinner-container">
                            <mat-spinner diameter="32"></mat-spinner>
                        </div>
                        }
                    </fieldset>
                    <fieldset
                        style="display: flex; flex-direction: column; gap: 10px; border-radius: var(--nexus-border-radius);">
                        <legend>Contact info</legend>
                        <div
                            style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 10px; border-radius: var(--nexus-border-radius); align-items: baseline">
                            <mat-form-field appearance="outline" style="flex: 1 1 0; min-width: 100px;">
                                <mat-label>Email 1</mat-label>
                                <input matInput type="text" formControlName="email1" />
                                <mat-icon matPrefix>email</mat-icon>
                                @if (commonDataFG.get("email1")?.invalid) {
                                <mat-error> Missing or invalid email.</mat-error>
                                }
                                <mat-hint>
                                    @if ((duplicateEntryResource.status() == 'resolved') &&
                                    (((duplicateEntryResource.value()?.matchingItems ?? []).length > 0) ||
                                    ((duplicateEntryResource.value()?.similarItems ?? []).length > 0))){
                                    <span class="n-duplicate-warning">{{ duplicateEntryResource.value() |
                                        similarityList:'emailSimilarity':0.999:'email' }}</span>
                                    }
                                    @if (duplicateEntryResource.status() == 'error') {
                                    <span class="n-duplicate-error">Error checking for similar entries</span>
                                    }
                                </mat-hint>
                            </mat-form-field>
                            <mat-form-field appearance="outline" style="flex: 1 1 0; min-width: 100px;">
                                <mat-label>Email 2</mat-label>
                                <input matInput type="text" formControlName="email2" />
                                <mat-icon matPrefix>email</mat-icon>
                                @if (commonDataFG.get("email2")?.invalid) {
                                <mat-error> Invalid email.</mat-error>
                                }
                            </mat-form-field>
                            <app-phone-number [formGroup]="phoneNumberFG" [required]="false"
                                style="flex: 1 2 0; min-width: 100px;" />
                        </div>
                    </fieldset>
                    <fieldset style="display:flex; flex-direction:column; gap:10px; border-radius: 5px ; ">
                        <legend>Postal address</legend>
                        <div style="font-size: smaller; margin-top: 0px;">Do not repeat the postal address (especially
                            country) if it's the same of the
                            organisation to which the contact is affiliated. Add it only if it's different.</div>
                        <app-postal-address [formGroup]="postalAddressFG" [addressRequired]="false"
                            style="display: flex; gap: 10px; border-radius: 5px" />

                    </fieldset>
                    <fieldset style="display: flex; flex-direction: column;  align-content: flex-start; gap: 10px;  border-radius: var(--nexus-border-radius);
                    border-width: 2px; padding-left: 10px; padding-top: 5px;">
                        <legend>LinkedIn Info</legend>
                        @if (authService.isRegularUser) {
                        <div style="color: var(--nexus-warm-orange); font-style:italic; padding-bottom: 3px">
                            <i class="fa-solid fa-ban"></i>You do not have permission to edit this data
                        </div>
                        }
                        <div
                            style="display: flex; flex-direction: row;  align-items:center; gap: 10px;  border-radius: var(--nexus-border-radius); padding-top: 5px;">
                            <mat-form-field appearance="outline" [style.width.px]="350">
                                <mat-label>LinkedIn profile</mat-label>
                                <input matInput type="text" formControlName="linkedInProfile" appUrlNormalizer />
                                <button matIconButton matSuffix aria-label="open in new tab"
                                    style="margin-bottom: 20px;"
                                    (click)="openUrl(commonDataFG.get('linkedInProfile')?.value)"
                                    [disabled]="!commonDataFG.get('linkedInProfile')?.value">
                                    <mat-icon>open_in_new</mat-icon>
                                </button>
                                @if (commonDataFG.get("linkedInProfile")?.hasError("invalidUrl") &&
                                (commonDataFG.get("linkedInProfile")?.touched ||
                                commonDataFG.get("linkedInProfile")?.dirty)) {
                                <mat-error>Invalid URL</mat-error>
                                }
                            </mat-form-field>
                            <mat-radio-group formControlName="linkedInStatus" style="margin-bottom: 20px;">
                                <mat-radio-button [value]="LinkedInStatus.CONNECTED">Connected</mat-radio-button>
                                <mat-radio-button [value]="LinkedInStatus.INVITATION_SENT">Invitation
                                    sent
                                </mat-radio-button>
                                <mat-radio-button [value]="LinkedInStatus.NOT_CONNECTED">Not
                                    connected</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </fieldset>
                    <fieldset
                        style="display: flex; flex-direction: column;  gap: 10px;  border-radius: var(--nexus-border-radius); ">
                        <legend style="display: flex; flex-direction: row; gap: 10px; align-items: center">Affiliations
                            <!-- @if (contact.id) {
                        <button matIconButton type="button" matTooltip="History">
                            <mat-icon>history</mat-icon>
                        </button>
                        } -->
                        </legend>
                        <!-- && affiliationsFA.touched -->
                        @if (affiliationsFA.hasError("duplicateOrganisation") ) {
                        <mat-error style="margin-bottom: 10px; display: block">
                            A contact can't be associated twice to the same organisation
                        </mat-error>
                        }
                        <div formArrayName="affiliationsFA">
                            @for (affiliation of affiliationsFA.controls;
                            track affiliation;
                            let i = $index) {
                            <div class="n-affiliation-row" [formGroupName]="i">
                                <mat-form-field class="n-position-field" appearance="outline">
                                    <mat-label>Position</mat-label>
                                    <input matInput formControlName="position" placeholder="Position" />
                                </mat-form-field>
                                <app-searchable-select class="n-organisation-field" appearance="outline"
                                    hint="To add an organisation, type its name and press enter" [showLink]="true"
                                    linkItem="organisation" formControlName="organisation" label="Organisation"
                                    itemName="organisation" [options]="allOrganisationOptions()" prefixIcon="domain"
                                    [displayAlternateName]="true" (addOption)="onAddOrganisation($event)"
                                    [allowNewItem]="true" />
                                <mat-form-field class="n-recorded-on-field" appearance="outline" label="">
                                    <mat-label>Recorded on</mat-label>
                                    <input matInput readonly
                                        [value]="affiliation.get('recordedDate')?.value | date:'dd-MM-yyyy'" />
                                </mat-form-field>
                                <div class="n-contact-type">
                                    <div class="mat-outline-group">
                                        <span class="mat-outline-label" style="height: auto; margin-top: -2px; ">Contact
                                            type</span>
                                        <div class="mat-outline-content">
                                            <span matTooltip="Primary contact" matTooltipPosition="above">
                                                <button type="button" matIconButton disabled>
                                                    <mat-icon
                                                        [style.color]="affiliation.get('primaryContact')?.value ? 'var(--nexus-fir)' : 'grey'">
                                                        account_circle </mat-icon>
                                                </button>
                                            </span>
                                            <span matTooltip="Invoicing contact" matTooltipPosition="above">
                                                <button type="button" matIconButton disabled>
                                                    <mat-icon
                                                        [style.color]="affiliation.get('invoicingContact')?.value ? 'var(--nexus-fir)' : 'grey'">
                                                        receipt </mat-icon>
                                                </button>
                                            </span>
                                            <span matTooltip="Contract contact" matTooltipPosition="above">
                                                <button type="button" matIconButton disabled>
                                                    <mat-icon
                                                        [style.color]="affiliation.get('contractContact')?.value ? 'var(--nexus-fir)' : 'grey'">
                                                        card_travel </mat-icon>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                    @if (affiliation.get('organisation')?.value?.member) {
                                    <div class="mat-body-small" style="font-size: 12px; padding-left: 5px">
                                        Primary/Invoicing/Contract
                                    </div>
                                    } @else {
                                    <div class="mat-body-small" style="font-size: 12px; padding-left: 5px">For
                                        members only
                                    </div>
                                    }
                                </div>
                                <div style="display: flex; padding-top: 8px">
                                    <button matMiniFab type="button" class="n-delete-button"
                                        matTooltip="Delete affiliation" (click)="deleteAffiliation(i)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <div>
                                @if (affiliation.hasError("rowEmpty") && affiliation.touched) {
                                <mat-error style="font-size: small; padding-left: 15px; margin-top: -20px;">Please
                                    fill in at least one field
                                </mat-error>
                                }
                            </div>
                            }
                        </div>
                        <button matMiniFab type="button" class="n-add-button" matTooltip="Add affiliation"
                            (click)="addAffiliation()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </fieldset>

                    <fieldset
                        style=" display: flex; flex-direction: column;  align-items:baseline; gap: 10px;  border-radius: var(--nexus-border-radius); ">
                        <legend>Involvement with EUFIC</legend>
                        <mat-form-field appearance="outline" class="n-full-width-field">
                            <mat-label>Stakeholder groups
                                @if (commonDataFG.controls['stakeholderGroups']?.hasValidator(Validators.required)) {
                                *
                                }
                            </mat-label>
                            <app-advanced-chip-select #stakeholderGroupsSelect placeholder="Add group..."
                                formControlName="stakeholderGroups" [allOptions]="allStakeholderGroupOptions()" />
                            @if (commonDataFG.controls['stakeholderGroups'].hasError('required') &&
                            commonDataFG.controls['stakeholderGroups'].touched) {
                            <mat-error>Select at least one group</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="n-full-width-field">
                            <mat-label>Topics of interest</mat-label>
                            <app-advanced-chip-select #topicsSelect placeholder="Add topic..." formControlName="topics"
                                [allOptions]="allTopicOptions()" />
                            <mat-hint>Add only the topics that you are sure the contact is interested in</mat-hint>
                            @if (commonDataFG.controls['topics'].hasError('required')) {
                            <mat-error>Select at least one topic</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="n-full-width-field">
                            <mat-label>Projects with EUFIC</mat-label>
                            <app-advanced-chip-select #projectsSelect placeholder="Add project..."
                                formControlName="projects" [allOptions]="allProjectOptions()" />
                            <mat-hint>You can add new projects from the <i>projects</i> screen</mat-hint>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="n-full-width-field">
                            <mat-label>Initiatives</mat-label>
                            <app-advanced-chip-select #initiativesSelect placeholder="Add initiative..."
                                formControlName="initiatives" [allOptions]="allInitiativeOptions()"
                                (addOption)="onAddInitiative($event)" [_allowNewItem]="true" />
                            <mat-hint>To add a new initiative, type it and press enter</mat-hint>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="n-full-width-field">
                            <mat-label>Events</mat-label>
                            <app-advanced-chip-select #eventsSelect placeholder="Add event..." formControlName="events"
                                [allOptions]="allEventOptions()" />
                            <mat-hint>You can add a new event from the <i>Events</i> screen</mat-hint>
                        </mat-form-field>
                    </fieldset>
                    <fieldset
                        style="margin-bottom: 15px; border-radius: var(--nexus-border-radius); display: flex; flex-direction: row; flex-wrap: wrap">
                        <legend>Governance roles</legend>
                        <section class="example-section">
                            <mat-checkbox formControlName="boardOfDirectors" class="example-margin">Board of
                                Directors
                            </mat-checkbox>
                            <mat-checkbox formControlName="scientificAdvisoryBoard" class="example-margin">Scientific
                                Advisory Board
                            </mat-checkbox>
                            <mat-checkbox formControlName="generalAssembly" class="example-margin">General Assembly
                            </mat-checkbox>
                            <mat-checkbox formControlName="executiveCommittee" class="example-margin">Executive
                                Committee
                            </mat-checkbox>
                            <mat-checkbox formControlName="nominationCommittee" class="example-margin">Nomination
                                committee
                            </mat-checkbox>
                            <mat-checkbox formControlName="ethicsCommittee" class="example-margin">Ethics Committee
                            </mat-checkbox>
                        </section>
                    </fieldset>

                    <fieldset formGroupName="optOuts"
                        style="margin-bottom: 15px; border-radius: var(--nexus-border-radius); display: flex; flex-direction: column; flex-wrap: wrap">
                        <legend>Communication preferences</legend>
                        @if (!authService.isActualAdmin) {
                        <div style="color: var(--nexus-warm-orange); font-style:italic; padding-bottom: 3px">
                            <i class="fa-solid fa-ban"></i>You do not have permission to edit this data
                        </div>
                        }
                        <section class="example-section">
                            <mat-checkbox formControlName="communicationType1OptIn" class="example-margin">Event
                                invitations
                            </mat-checkbox>
                            <mat-checkbox formControlName="communicationType2OptIn" class="example-margin">Training
                                opportunities
                            </mat-checkbox>
                            <mat-checkbox formControlName="communicationType3OptIn" class="example-margin">Activity
                                results
                                and flagship initiatives
                            </mat-checkbox>
                            <mat-checkbox formControlName="communicationType4OptIn" class="example-margin">Results from
                                research studies
                            </mat-checkbox>
                            <mat-checkbox formControlName="communicationType5OptIn" class="example-margin">Participation
                                in feedback surveys
                            </mat-checkbox>
                        </section>
                    </fieldset>

                    <mat-form-field appearance="outline" hintLabel="Max {{ additionalInfoMaxLen }} characters"
                        style="margin-top: 10px">
                        <mat-label>Additional information</mat-label>
                        <textarea matInput formControlName="additionalInfo" rows="5" cols="100"></textarea>
                        <mat-hint align="end">{{ commonDataFG.get("additionalInfo")?.value?.length || 0 }}/{{
                            additionalInfoMaxLen
                            }}
                        </mat-hint>
                    </mat-form-field>
                </div>
            </form>
        </mat-expansion-panel>
        <mat-expansion-panel class="n-supplier-data-panel" [expanded]="true"
            [style.background-color]="(contact.archived ? 'var(--nexus-archived-color)' : (isSupplier() ? 'var(--nexus-supplier-data-bgcolor)' : 'inherit'))">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-checkbox matTooltip="Select if contact is also a supplier" matTooltipPosition="above"
                        [checked]="isSupplier()" (click)="$event.stopPropagation();" (change)="toggleSupplier($event)">
                    </mat-checkbox>
                    <span>Supplier details</span>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div style="padding: 0 15px 10px 15px; font-style:italic">
                Fill in this section only if the contact is a freelance/self-employed supplier. If the contact is
                affiliated to an organisation that is also a supplier, you must fill in the supplier section from the organisation
                panel.
            </div>
            <form [formGroup]="supplierDataFG" class="form-container">
                <div style="padding: 6px; display: flex; flex-direction: column; gap: 10px">
                    <fieldset
                        style=" display: flex; flex-direction: row; flex-wrap: wrap; gap: 10px; border-radius: var(--nexus-border-radius); ">
                        <legend>Administrative data</legend>
                        <mat-form-field appearance="outline" class="n-half-width r-field r-inputfield">
                            <mat-label>Tax Id</mat-label>
                            <input matInput placeholder="Tax Id" formControlName="taxId" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="n-half-width r-field r-inputfield">
                            <mat-label>Website</mat-label>
                            <mat-icon matPrefix>link</mat-icon>
                            <input matInput placeholder="Website" formControlName="website" appUrlNormalizer />
                            @if (supplierDataFG.get("website")?.hasError("invalidUrl")) {
                            <mat-error>Invalid URL</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="n-half-width r-field r-inputfield">
                            <mat-label>Email</mat-label>
                            <mat-icon matPrefix>email</mat-icon>
                            <input matInput placeholder="Website" formControlName="supplierEmail" />
                            @if (supplierDataFG.get("supplierEmail")?.hasError("invalidEmail")) {
                            <mat-error>Invalid email</mat-error>
                            }
                        </mat-form-field>
                        <!-- <mat-form-field appearance="outline" class="n-half-width r-field r-inputfield">
                        <mat-label>Drive folder</mat-label>
                        <mat-icon matPrefix>folder</mat-icon>
                        <input matInput placeholder="Drive folder" formControlName="driveFolder" />
                        <mat-hint>Add path to S drive folder where contracts/quotations are stored
                        </mat-hint>
                    </mat-form-field> -->
                    </fieldset>
                    <fieldset
                        style="display: flex; flex-direction: column; gap: 10px; border-radius: var(--nexus-border-radius); margin-top: 10px;">
                        <legend>Relationship</legend>
                        <div>
                            <label>Did we work with them?</label>
                            <mat-radio-group formControlName="ongoingRelationship">
                                <mat-radio-button [value]="OngoingRelationship.YES">Yes</mat-radio-button>
                                <mat-radio-button [value]="OngoingRelationship.QUOTATION_ONLY">Quotation
                                    only
                                </mat-radio-button>
                                <mat-radio-button [value]="OngoingRelationship.NOT_YET">Not yet</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <!-- <div>
                        <label>Feedback</label>
                        <mat-radio-group formControlName="supplierFeedback">
                            <mat-radio-button [value]="SupplierFeedback.GOOD">Good</mat-radio-button>
                            <mat-radio-button [value]="SupplierFeedback.AVERAGE">Average</mat-radio-button>
                            <mat-radio-button [value]="SupplierFeedback.AVOID">Avoid</mat-radio-button>
                            <mat-radio-button [value]="SupplierFeedback.NOT_YET">Not sure</mat-radio-button>
                        </mat-radio-group>
                    </div> -->
                    </fieldset>
                    <fieldset
                        style="display: flex; flex-direction: column; gap: 10px; border-radius: var(--nexus-border-radius); margin-top: 10px;">
                        <legend>Products</legend>
                        <mat-form-field appearance="outline" class="long-field">
                            <mat-label>Products</mat-label>
                            <app-advanced-chip-select #productsSelect placeholder="Add product..." required
                                formControlName="products" [allOptions]="allProductOptions()" />
                            <mat-error>At least one product must be selected</mat-error>
                        </mat-form-field>
                    </fieldset>
                    <mat-form-field appearance="outline" hintLabel="Max {{ additionalInfoMaxLen }} characters"
                        style="margin-top: 10px">
                        <mat-label>Additional information</mat-label>
                        <textarea matInput formControlName="additionalInfo" rows="5" cols="100"></textarea>
                        <mat-hint align="end">{{ supplierDataFG.get("additionalInfo")?.value?.length || 0 }}/{{
                            additionalInfoMaxLen
                            }}
                        </mat-hint>
                    </mat-form-field>
                </div>
            </form>
        </mat-expansion-panel>
    </mat-accordion>

    @if (contact.id) {
    <app-history-panel entityType="contact" [entityId]="contact.id"></app-history-panel>
    }

    <div class="n-button-row">
        <button matFab extended class="n-cancel-button" (click)="cancel()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button matFab extended class="n-save-button" (click)="save()">
            <mat-icon>save</mat-icon>
            {{ mode === "Create" ? "Save" : "Update" }}
        </button>
        @if (mode === "Update") {
        <button matFab extended class="n-archive-button" (click)="toggleArchive()">
            <mat-icon>{{contact.archived ? 'unarchive' : 'archive'}}</mat-icon>
            {{contact.archived ? 'Un-archive' : 'Archive'}}
        </button>
        <button matFab extended class="n-delete-button" (click)="delete()" [disabled]="!authService.isAdmin">
            <mat-icon>delete</mat-icon>
            Delete
        </button>
        }
    </div>
</div>